/* eslint-disable max-len */
import { DUAL_PATH_CATEGORIES } from '@thd-olt-functional/utils';

// constants
export const leftPodTitle = 'Trusted Installers';
export const leftPodDetails = 'All our installers are local, licensed and insured, and we background check everyone who will come into your home.';
export const rightPodTitle = 'Same-Day Installation';
export const rightPodDetails = 'Same day water heater installation is available Monday-Friday if you request install before noon and live 30 miles of a Home Depot store.';

// utils

export const buildServiceReviewsUrl = (category) => {
  const reviewUrls = {
    [DUAL_PATH_CATEGORIES.TANKLESS_WATER_HEATER]: 'tankless-water-heater-installation/c88b47f07',
    [DUAL_PATH_CATEGORIES.TANK_WATER_HEATER]: 'water-heater-installation/9058c024e',
  };

  return reviewUrls[category] && (
      `/services/c/${reviewUrls[category]}/reviews/page/1`);
};